import { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "./useHandleError";

export function useAccountBalance(accountNumber) {
  const handleError = useHandleError();
  const [balance, setBalance] = useState(null);
  const [loadingBalance, setLoadingBalance] = useState(false);

  const fetchBalance = async () => {
    if (!accountNumber) {
      setBalance(null);
      return;
    }
    setLoadingBalance(true);
    try {
      const res = await axios.get(`${BASE_URL}/MT5M/get_account_balance?account_number=${accountNumber}`, {
        headers: getApiHeaders()
      });
      // const res = await axios.post(`${BASE_URL}/MT5M/get_account_balance?account_number=${accountNumber}`, {}, {
      //   headers: getApiHeaders()
      // });
      if (res.data && (res.data.code === 200 || res.data.status === "success") && res.data.data) {
        setBalance(res.data.data.balance);
      } else {
        setBalance(null);
      }
    } catch (error) {
      setBalance(null);
      handleError(error);
    } finally {
      setLoadingBalance(false);
    }
  };

  useEffect(() => {
    fetchBalance();
  }, [accountNumber]);

  return { balance, loadingBalance, fetchBalance };
}
